import { addAnalytics } from '../api/analytics';
import { getAnonymousId, makeId } from './anonymousId';
import { getLeadRef } from './leadRef';

const SESSION_KEY = 'trvto_session_id';

// -----------------------------------------
// Get / create session ID
// -----------------------------------------

const getSessionId = () => {
    try {
        let sessionId = sessionStorage.getItem(SESSION_KEY);

        if (!sessionId) {
            sessionId = makeId();

            sessionStorage.setItem(SESSION_KEY, sessionId);
        }

        return sessionId;
    } catch (e) {
        return makeId();
    }
};

// -----------------------------------------
// Main tracking function
// -----------------------------------------

export const trackEvent = async ({ event, page, tripId, dateId, bookingId, metadata = {} }) => {
    try {
        await addAnalytics({
            event,

            sessionId: getSessionId(),

            anonymousId: getAnonymousId(),

            page: page || window.location.pathname,

            tripId: tripId || null,

            dateId: dateId || null,

            bookingId: bookingId || null,

            metadata,

            platform: 'web',

            // chatbot lead code, if this visitor came from a WhatsApp / Instagram link
            leadRef: getLeadRef()
        });
    } catch (error) {
        // Never affect website functionality
        console.error('Analytics failed:', error);
    }
};
